import React, { useRef,useState } from 'react'
import styles from './influencerSec.module.css'
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import useTextAnimation from "../../hooks/useTextAnimation.js";
import { abtProg, contCre, influnceSlide1, influnceSlide2, influnceSlide3, influnceSlide4, leftArrow, rgtArrow } from '../../../assets'
import { Link } from 'react-router-dom'
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { FreeMode, Navigation, Pagination, Thumbs, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react'
import { CCBslider, CCslider } from '../../../constants';
import { IMAGE_URL } from '../../helpers/api_helper.jsx';
import { useTranslation } from 'react-i18next';
import '../../../i18n';
import { LANG_AR, LANG_EN } from '../../helpers/constant';
import VideoPopup from '../videoPopup/VideoPopup.jsx';


const InfluencerHighlights = ({ influencerData, handlePlayClick}) => {
    const swiperRef = useRef(null);
    const swiperRef1 = useRef(null);

    const highlights = influencerData.influencer;
    const contentCreators = influencerData.contentCreator;
    const campaignResults = influencerData.campaignResult;

    const { ref: headingRef, inView: headingInView, textAnimation } = useTextAnimation();
    const { ref: heading1Ref, inView: heading1InView } = useTextAnimation();
    const { ref: heading2Ref, inView: heading2InView } = useTextAnimation();
    const { ref: paragraphRef, inView: paragraphInView } = useTextAnimation();
    const { ref: paragraph1Ref, inView: paragraph1InView } = useTextAnimation();
    const { ref: paragraph2Ref, inView: paragraph2InView } = useTextAnimation();

    const { t, i18n } = useTranslation();
    const [isVideoPopupOpen, setIsVideoPopupOpen] = useState(false);
    const [currentVideoSrc, setCurrentVideoSrc] = useState('');
       const videoPopupRef = useRef(null);
        const popupVideoRef = useRef(null);
        const videoRef = useRef(null);

    const openVideoPopup = (videoSrc) => {
        setCurrentVideoSrc(videoSrc);
        setIsVideoPopupOpen(true);
    };

    const closeVideoPopup = () => {
        setIsVideoPopupOpen(false);
        setCurrentVideoSrc('');
    };

    

    const handleCloseClick = () => {
        setIsVideoPopupOpen(false);
    };


    return (
        <>
        <div className={styles.InfluencerHighlights}>
            {/* Video Popup Modal */}
            {/* {isVideoPopupOpen && (
                <div className={styles.videoPopupOverlay} onClick={closeVideoPopup}>
                    <div className={styles.videoPopupContainer} onClick={(e) => e.stopPropagation()}>
                        <button className={styles.closeButton} onClick={closeVideoPopup}>
                            &times;
                        </button>
                        <video
                            src={currentVideoSrc}
                            controls
                            autoPlay
                            className={styles.popupVideo}
                        />
                    </div>
                </div>
            )}
 */}
            
            
            
            <div className={`${styles.InfluencerHighlights_inner}`}>
                <motion.div className={styles.InfluencerHighlights_title}
                    ref={headingRef}
                    initial="hidden"
                    animate={headingInView ? "visible" : "hidden"}
                    custom={0}
                    variants={textAnimation}
                >
                   {/*  <h3>{t('highlight')} <span>{t('success')}</span></h3> */}
                    <h3>{t('highlight')} {t('success')}</h3>
                </motion.div>
                {highlights?.successDescription && <motion.div className={styles.InfluencerHighlights_stitle}
                    ref={paragraphRef}
                    initial="hidden"
                    animate={paragraphInView ? "visible" : "hidden"}
                    custom={1}
                    variants={textAnimation}
                >
                    {/* <p>As a leading influencer marketing agency in the UAE, we have partnered with brands across diverse industries to craft and execute high-impact influencer marketing campaigns. Through strategic collaborations and innovative storytelling, we help brands grow their presence and connect authentically with their audiences. Beyond campaigns, we are shaping the future of influencer marketing with initiatives like Content Masters, Abu Dhabi's first & largest in the middle east, a pioneering program designed to empower aspiring creators and grow their influence within their communities and beyond. </p> */}
                    {/* <p dangerouslySetInnerHTML={{ __html: highlights?.successDescription }}></p> */}
                    <p dangerouslySetInnerHTML={{ __html: i18n.language === LANG_EN ? highlights?.successDescription : highlights?.successDescriptionAr }}></p>

                </motion.div>}
            </div>
            <div className={styles.InfluencerHighlights_abtprogram}>
                <div className={styles.InfluencerHighlights_abtprogramInner}>
                    <div className={`${styles.InfluencerHighlights_abtprogramCont} ${i18n.language === LANG_AR ? 'arab' : ''}`}>
                        <div className={`${styles.InfluencerHighlights_abtprogramContL} ${i18n.language === LANG_AR ? 'arabText' : ''}`}>
                            {/*  <h3>About the program</h3>
                            <p>The Content Masters is a dedicated program that has successfully completed two seasons, designed to empower aspiring content creators to become more influential by providing them with the skills and tools needed to excel on any influencer advertising platform and leverage Instagram influencer marketing to build a stronger digital presence.</p> */}

                            {/* <h3>{highlights?.aboutSuccessTitle}</h3> */}
                            <h3>{i18n.language === LANG_EN ? highlights?.aboutSuccessTitle : highlights?.aboutSuccessTitleAr}</h3>

                            {/* <h2>{highlights?.aboutSuccessSubtitle}</h2> */}
                            <h2>{i18n.language === LANG_EN ? highlights?.aboutSuccessSubtitle : highlights?.aboutSuccessSubtitleAr}</h2>

                            {/* <p dangerouslySetInnerHTML={{ __html: highlights?.aboutSuccessDesc }}></p> */}
                            <p dangerouslySetInnerHTML={{ __html: i18n.language === LANG_EN ? highlights?.aboutSuccessDesc : highlights?.aboutSuccessDescAr }}></p>

                            <ul className={`${styles.InfluencerHighlights_abtproContList} ${i18n.language === LANG_AR ? 'arab' : ''}`}>
                                <li>
                                    {/* <h3>100+</h3>
                                    <p>Total in house participants</p> */}
                                    <h3>{highlights?.successTotalParticipants}</h3>
                                    {/* <p dangerouslySetInnerHTML={{ __html: highlights?.successParticipantsTitle }}></p> */}
                                    <p dangerouslySetInnerHTML={{ __html: i18n.language === LANG_EN ? highlights?.successParticipantsTitle : highlights?.successParticipantsTitleAr }}></p>
                                </li>
                                <li>
                                    {/* <h3>5000+</h3>
                                    <p>Total onlines attendees from around the Arab world</p> */}
                                    <h3>{highlights?.totalOnlineAttendes}</h3>
                                    {/* <p dangerouslySetInnerHTML={{ __html: highlights?.onlineAttendesdesc }}></p> */}
                                    <p dangerouslySetInnerHTML={{ __html: i18n.language === LANG_EN ? highlights?.onlineAttendesdesc : highlights?.onlineAttendesDescAr }}></p>
                                </li>
                                <li>
                                    {/* <h3>15M+</h3>
                                    <p>Participants followers growth</p> */}
                                    <h3>{highlights?.totalParticipantsFollower}</h3>
                                    {/* <p dangerouslySetInnerHTML={{ __html: highlights?.totalParticipantsFollowerTitle }}></p> */}
                                    <p dangerouslySetInnerHTML={{ __html: i18n.language === LANG_EN ? highlights?.totalParticipantsFollowerTitle : highlights?.totalParticipantsFollowerTitleAr }}></p>
                                </li>
                            </ul>
                        </div>
                        <div className={styles.InfluencerHighlights_abtprogramContR}>
                            {/* <img  src={abtProg} alt=""   */}
                            {/* src={`${IMAGE_URL}/influencer/${highlights?.imageAboutSuccess}`}  */}

                            {highlights?.imageAboutSuccess.endsWith('.mp4') || highlights?.imageAboutSuccess.endsWith('.webm') || highlights?.imageAboutSuccess.endsWith('.ogg') ? (
                                <video
                                //onClick={() => openVideoPopup(`${IMAGE_URL}/influencer/${highlights?.imageAboutSuccess}`)}
                                onClick={()=> handlePlayClick(`${IMAGE_URL}/influencer/${highlights?.imageAboutSuccess}`)}
                                    src={`${IMAGE_URL}/influencer/${highlights?.imageAboutSuccess}`}
                                    autoPlay
                                    muted
                                    loop
                                    playsInline
                                    className={styles.video}
                                />
                            ) : (
                                <img
                                    src={`${IMAGE_URL}/influencer/${highlights?.imageAboutSuccess}`}
                                    // alt={title}
                                    className={styles.imageAboutSuccess}
                                    loading='lazy'
                                />
                            )
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.InfluencerHighlights_inner}>
                <motion.div className={styles.InfluencerHighlights_title}
                    ref={heading1Ref}
                    initial="hidden"
                    animate={heading1InView ? "visible" : "hidden"}
                    custom={0}
                    variants={textAnimation}
                >
                    {/* <h3>Our Exclusive Content Creators</h3> */}
                    {/* <h3>{highlights?.contentCreatorsTitle}</h3> */}
                    <h3>{i18n.language === LANG_EN ? highlights?.contentCreatorsTitle : highlights?.contentCreatorsTitleAr}</h3>
                </motion.div>
                <motion.div className={styles.InfluencerHighlights_stitle}
                    ref={paragraph1Ref}
                    initial="hidden"
                    animate={paragraph1InView ? "visible" : "hidden"}
                    custom={1}
                    variants={textAnimation}
                >
                    {/* <p>Discover the power of our exclusive network of top-tier content creators!  Find influencers for your brand and elevate it with impactful collaborations that get people talking and drive real results. Work with unique talents who bring fresh ideas, creativity, and authenticity to every campaign.</p> */}
                    {/* <p dangerouslySetInnerHTML={{ __html: highlights?.contentCreatorsDesc }}></p> */}
                    <p dangerouslySetInnerHTML={{ __html: i18n.language === LANG_EN ? highlights?.contentCreatorsDesc : highlights?.contentCreatorsDescAr }}></p>
                </motion.div>
            </div>
            <div className={styles.InfluencerHighlights_abtprogram}>
                <div className={styles.InfluencerHighlights_abtprogramInner}>
                    <Swiper
                        className={styles.InfluencerHighlights_abtproSlides}
                        ref={swiperRef}
                        slidesPerView={4}
                        pagination={false}
                        loop={true}
                        autoHeight={true}
                        modules={[Pagination, Navigation, Autoplay]}
                        // autoplay={{ delay: 5000 }}
                        autoplay={false}
                        navigation={false}
                        spaceBetween={10}
                        onSwiper={(swiper) => (swiperRef.current = swiper)}
                        breakpoints={{
                            320: { slidesPerView: 1, spaceBetween: 10 },
                            640: { slidesPerView: 2, spaceBetween: 10 },
                            768: { slidesPerView: 2, spaceBetween: 10 },
                            1024: { slidesPerView: 3, spaceBetween: 10 },
                            1300: { slidesPerView: 4, spaceBetween: 10 }
                        }}
                    >
                        {/*  {CCslider.map((ccSlides, index) => (
                            <SwiperSlide key={index}>
                                <div className={styles.InfluencerHighlights_abtproCard}>
                                    <div className={styles.InfluencerHighlights_abtproCardImg}>
                                        <img src={ccSlides.img} alt="" />
                                    </div>
                                    <div className={styles.InfluencerHighlights_abtproCardDisc}>
                                        <h2>{ccSlides.title}</h2>
                                        <h3>{ccSlides.stitle}</h3>
                                        <p>{ccSlides.disc}</p>
                                        <ul className={styles.InfluencerHighlights_abtproCardLinks}>
                                            {ccSlides.slinks.map((slink, sindex) => (
                                                <li key={sindex}>
                                                    <Link to={slink.link} target='_blank'>
                                                        {slink.icon}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))} */}

                        {contentCreators?.map((creator, index) => (
                            <SwiperSlide key={index}>
                                <div className={`${styles.InfluencerHighlights_abtproCard} ${i18n.language === LANG_AR ? 'arabText' : ''}`}>
                                    <div className={styles.InfluencerHighlights_abtproCardImg}>
                                        {/* <img src={ccSlides.img} alt="" /> */}
                                        <img src={`${IMAGE_URL}/contentCreator/${creator.image}`} loading='lazy' />
                                    </div>
                                    <div className={styles.InfluencerHighlights_abtproCardDisc}>
                                        {/* <h2>{creator?.name}</h2> */}
                                        <h2>{i18n.language === LANG_EN ? creator?.name : creator?.nameAr}</h2>

                                        {/* <h3>{creator?.creatorCategory}</h3> */}
                                        <h3>{i18n.language === LANG_EN ? creator?.creatorCategory : creator?.creatorCategoryAr}</h3>

                                        {/* <p dangerouslySetInnerHTML={{ __html: creator?.description }}></p> */}
                                        <p dangerouslySetInnerHTML={{ __html: i18n.language === LANG_EN ? creator?.description : creator?.descriptionAr }}></p>


                                        <ul className={`${styles.InfluencerHighlights_abtproCardLinks} ${i18n.language === LANG_AR ? 'arab' : ''}`}>
                                            {creator?.platforms?.map((slink, sindex) => (
                                                <li key={sindex}>
                                                    <Link to={slink.url} target='_blank'>
                                                        {/* {slink.icon} */}
                                                        {/* <img src={`${IMAGE_URL}/contentCreator/${slink.icon}`} /> */}
                                                        <img
                                                            src={`${IMAGE_URL}/contentCreator/${slink.icon}`}
                                                            /* style={{ width: "50px", height: "50px" }} */
                                                            alt="icon"
                                                        />

                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <div className={styles.customNavigation}>
                        <button
                            className={styles.prevButton}
                            onClick={() => swiperRef.current?.slidePrev()}
                        >
                            <img src={leftArrow} alt="" />
                        </button>
                        <button
                            className={styles.nextButton}
                            onClick={() => swiperRef.current?.slideNext()}
                        >
                            <img src={rgtArrow} alt="" />
                        </button>
                    </div>
                </div>
            </div>
            <div className={styles.InfluencerHighlights_inner}>
                <motion.div className={styles.InfluencerHighlights_title}
                    ref={heading2Ref}
                    initial="hidden"
                    animate={heading2InView ? "visible" : "hidden"}
                    custom={0}
                    variants={textAnimation}
                >
                    {/* <h3>Campaigns & Results</h3> */}
                    {/* <h3>{highlights?.campaignTitle}</h3> */}
                    <h3>{i18n.language === LANG_EN ? highlights?.campaignTitle : highlights?.campaignTitleAr}</h3>
                </motion.div>
                <motion.div className={styles.InfluencerHighlights_stitle}
                    ref={paragraph2Ref}
                    initial="hidden"
                    animate={paragraph2InView ? "visible" : "hidden"}
                    custom={1}
                    variants={textAnimation}
                >
                    {/* <p>Our content creators have played a vital role in various events and campaigns, building on their own successful portfolios while also supporting the success of our clients and partners. Here are some notable examples</p> */}
                    {/* <p dangerouslySetInnerHTML={{ __html: highlights?.campaignDesc }}></p> */}
                    <p dangerouslySetInnerHTML={{ __html: i18n.language === LANG_EN ? highlights?.campaignDesc : highlights?.campaignDescAr }}></p>
                </motion.div>
            </div>
            <div className={styles.InfluencerHighlights_abtprogram}>
                <div className={styles.InfluencerHighlights_abtprogramInner}>
                    <Swiper
                        className={styles.InfluencerHighlights_abtprogramInnerslides}
                        ref={swiperRef1}
                        slidesPerView={1}
                        pagination={false}
                        // autoHeight={true}
                        loop={true}
                        modules={[Pagination, Navigation, Autoplay]}
                        // autoplay={{ delay: 5000 }}
                        autoplay={false}
                        navigation={false}
                        onSwiper={(swiper) => (swiperRef1.current = swiper)}
                        breakpoints={{
                            320: { slidesPerView: 1, },
                            640: { slidesPerView: 1, },
                            768: { slidesPerView: 1, },
                            1024: { slidesPerView: 1, },
                        }}
                    >
                        {/*  {CCBslider.map((slides, index) => (
                            <SwiperSlide key={index}>
                                <div className={styles.InfluencerHighlights_abtprogramCont}>
                                    <div className={styles.InfluencerHighlights_abtprogramContL}>
                                        <h3>{slides.title}</h3>
                                        <p>{slides.stitle}</p>
                                        <ul className={styles.InfluencerHighlights_abtproContList}>
                                            {slides.states.map((states, index) => (
                                                <li key={index}>
                                                    <h3>{states.count}</h3>
                                                    <p>{states.disc}</p>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className={styles.InfluencerHighlights_abtprogramContR}>
                                        <img src={slides.img} alt="" />
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))} */}


                        {campaignResults?.map((campaign, index) => (
                            <SwiperSlide key={index}>
                                <div className={`${styles.InfluencerHighlights_abtprogramCont} ${i18n.language === LANG_AR ? 'arab' : ''}`}>
                                    <div className={`${styles.InfluencerHighlights_abtprogramContL} ${i18n.language === LANG_AR ? 'arabText' : ''}`}>
                                        {/*  <h3>{campaign?.contentTitle}</h3> */}
                                        <h3>{i18n.language === LANG_EN ? campaign?.contentTitle : campaign?.contentTitleAr}</h3>
                                        {/* <p dangerouslySetInnerHTML={{ __html: campaign?.contentDesc }}></p> */}
                                        <p dangerouslySetInnerHTML={{ __html: i18n.language === LANG_EN ? campaign?.contentDesc : campaign?.contentDescAr }}></p>

                                        <ul className={`${styles.InfluencerHighlights_abtproContList} ${i18n.language === LANG_AR ? 'arab' : ''}`}>
                                            <li>
                                                <h3>{campaign?.totalViews}</h3>
                                                {/* <p dangerouslySetInnerHTML={{ __html: campaign?.viewsTitle }}></p> */}
                                                <p dangerouslySetInnerHTML={{ __html: i18n.language === LANG_EN ? campaign?.viewsTitle : campaign?.viewsTitleAr }}></p>
                                            </li>
                                            <li>

                                                <h3>{campaign?.totalInfluencers}</h3>
                                                {/* <p dangerouslySetInnerHTML={{ __html: campaign?.influencerTitle }}></p> */}
                                                <p dangerouslySetInnerHTML={{ __html: i18n.language === LANG_EN ? campaign?.influencerTitle : campaign?.influencerTitleAr }}></p>
                                            </li>

                                            <li>
                                                <h3>{campaign?.engagementRateValue}</h3>
                                                {/* <p dangerouslySetInnerHTML={{ __html: campaign?.engagementRateTitle }}></p> */}
                                                <p dangerouslySetInnerHTML={{ __html: i18n.language === LANG_EN ? campaign?.engagementRateTitle : campaign?.engagementRateTitleAr }}></p>
                                            </li>




                                            {/* {slides.states.map((states, index) => (
                                                <li key={index}>
                                                    <h3>{states.count}</h3>
                                                    <p>{states.disc}</p>
                                                </li>
                                            ))} */}
                                        </ul>
                                    </div>
                                    <div className={styles.InfluencerHighlights_abtprogramContR}>
                                        {/*  <img src={slides.img} alt="" /> */}
                                        <img src={`${IMAGE_URL}/campaignResult/${campaign?.image}`} loading='lazy' />
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <div className={styles.customNavigation}>
                        <button
                            className={styles.prevButton}
                            onClick={() => swiperRef1.current?.slidePrev()}
                        >
                            <img src={leftArrow} alt="" />
                        </button>
                        <button
                            className={styles.nextButton}
                            onClick={() => swiperRef1.current?.slideNext()}
                        >
                            <img src={rgtArrow} alt="" />
                        </button>


                    </div>
                </div>
            </div>

            

            
        </div>

        </>
    )
}

export default InfluencerHighlights
